export default __webpack_public_path__ + "static/media/xenia.1acc2f83.png";